import axios from '@axios'

const route = 'report'

function normalizeReports(reports) {
  if (Array.isArray(reports)) {
    return reports.map(item => String(item).trim()).filter(Boolean)
  }

  if (typeof reports === 'string') {
    return reports
      .split(',')
      .map(item => item.trim())
      .filter(Boolean)
  }

  return []
}

export default {
  namespaced: true,
  state: {
    favoriteReports: [],
    defaultReports: [],
  },
  getters: {
    getFavoriteReports(state) {
      return state.favoriteReports
    },
    getdefaultReports(state) {
      return state.favoriteReports
    },
  },
  mutations: {
    setFavoriteReports(state, reports) {
      const normalized = normalizeReports(reports)
      state.favoriteReports = normalized
      state.defaultReports = normalized
    },
    setdefaultReports(state, reports) {
      const normalized = normalizeReports(reports)
      state.favoriteReports = normalized
      state.defaultReports = normalized
    },
  },
  actions: {
    /**
     *
     * modifica a selecao do relatorio como favorito
     */
    toogleFavorite(context, report) {
      return axios.post(`${route}/toggle_favorite`, { report })
    },
    toogledefault(context, report) {
      return axios.post(`${route}/toggle_favorite`, { report }).then(response => {
        if (response?.data && response.data.report_default === undefined) {
          response.data.report_default = response.data.report_favorite
        }

        return response
      })
    },

    /**
     *
     * retorna os nome dos relatorios favoritos
     */
    getFavorite(context, report) {
      return axios.get(`${route}/get_favorite`)
    },
    getdefault(context, report) {
      return axios.get(`${route}/get_favorite`)
    },

  },
}
